// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"97a38051","399":"f2429062","502":"c93a245a","750":"b6279f55","808":"9e0e8df9"}[chunkId] + ".chunk.js";
};